/*
 * popup Actions
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 18-Jun-2025
 */

import { createAction } from './index'

export const actionTypes = {
  DO_SHOW_FLOATING: '@@floating/show_floating',
  DO_HIDE_FLOATING: '@@floating/hide_floating'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action
/** @action
* * Insert a description
* @name HideFloating
* @return {object} - The payload object
*/
export const doHideFloating = payload => createAction(actionTypes.DO_HIDE_FLOATING, { payload })
/** @action
* * Insert a description
* @name ShowFloating
* @return {object} - The payload object
*/
export const doShowFloating = (key, moreInfo, id) => createAction(actionTypes.DO_SHOW_FLOATING, { key, moreInfo, id })
